import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { IsNotEmpty } from "class-validator"
import { v4 } from "uuid"

@Serializable
export class CostCenterModel {
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["cost_center"],
  })
  uid: string = v4()
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["cost_center"],
  })
  name: string = ""
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["cost_center"],
  })
  ownerId: string = ""
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["cost_center"],
  })
  ownerName: string = ""
  // not important
  countryName: string = ""
  countryCode: string = ""
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["cost_center"],
  })
  splitPct: number = 100
  ion: string = ""

  constructor(init?: Partial<CostCenterModel>) {
    Object.assign(this, init)
  }
}
